import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { DashSelection } from "../app/app.model";

@Component(
    {
        name: 'nav_menu',
        components: {
        }
    }
)
export default class NavMenu extends Vue {
    @Prop({ required: true })
    selection!: DashSelection;
    
    private readonly menuItems: string[] = ['EDA', 'UF', 'CPO', 'CPA', 'TRI', 'BIO'];

    click(item: string): void {
        this.$emit('selected', item);
    }
}
